import { render, staticRenderFns } from "./approval-timeline.vue?vue&type=template&id=4f88a0a9&scoped=true&"
import script from "./approval-timeline.vue?vue&type=script&lang=js&"
export * from "./approval-timeline.vue?vue&type=script&lang=js&"
import style0 from "./approval-timeline.vue?vue&type=style&index=0&id=4f88a0a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f88a0a9",
  null
  
)

export default component.exports